import React, { Fragment } from "react";
import { useSession } from "next-auth/react";

import useSignOut from "../../../hooks/useSignOut";

import Icon from "../../../components/_ui/Icon/Icon";

import styles from "./AccountDropdown.module.css";
import Dropdown from "@/components/_ui/Dropdown/Dropdown";

const AccountDropdown = () => {
    const { data: session } = useSession();
    const signOut = useSignOut();

    if (!session) {
        return null;
    }

    let userName = "My account";

    if (session.user.firstname) {
        userName = session.user.firstname;
        userName = session.user.lastname ? `${userName} ${session.user.lastname}` : userName;
    }

    return (
        <Dropdown>
            {({ open }) => (
                <Fragment>
                    <Dropdown.Trigger>
                        <button type="button" className={`${styles.trigger} ${open ? styles.triggerActive : ""}`}>
                            <Icon icon="user" size="large" className="shrink-0" />
                            <span className="type-small-caps pt-0125 hidden min-[860px]:block">{userName}</span>
                        </button>
                    </Dropdown.Trigger>
                    <Dropdown.Items alignment="right">
                        <Dropdown.LinkItem href="/profile" label="Profile" icon="gear" />
                        <Dropdown.Separator />
                        <Dropdown.ButtonItem labelStyle="buttonLabel" variant="destructive" onClick={signOut} label="Sign out" icon="exit" iconPosition="after" />
                    </Dropdown.Items>
                </Fragment>
            )}
        </Dropdown>
    );
};

export default AccountDropdown;



